<template>
  <protection-base :product="product">
    <h3 class="mt-2" data-test="productTitle">
      {{ product.payload.product }}
    </h3>

    <!-- Temporary image placeholder for Lubrico (We currently do not have any product video for Lubrico as they are working on an update on the video) -->
    <!-- @TODO: Remove this once Lubrico gets back with an updated product video -->
    <img
      v-if="isLubrico"
      src="@/assets/lubrico_warranty_hero.png"
      :alt="$t(`message.spotlightV2.categories.protection.lubrico_warranty_hero_image`)"
      class="w-100"
    />
    <video-player
      v-if="!isLubrico && showVideoPlayer"
      class="mb-4 w-100 mx-auto"
      :video-id="product.payload.videoLinks[0].link"
      :product="product.internalName"
      data-test="videoPlayer"
    ></video-player>

    <router-link
      v-if="showMoreVideosLink"
      :to="{ path: `${product.internalName}/media-library` }"
      class="mt-4 font-weight-500 text-primary"
      @click.native="trackClick(`${product.category}.${product.internalName}`, 'more_videos')"
    >
      {{ $t(`message.spotlightV2.categories.protection.seeMoreVideos`) }}
    </router-link>

    <p class="mt-4 mb-4">
      {{ product.payload.description }}
    </p>
    <div v-for="(item, index) in product.payload.message" :key="index">
      <p v-if="!Array.isArray(item)">
        {{ item }}
      </p>
      <ul v-else class="benefits-list">
        <li v-for="(listItem, index) in item" :key="index">
          {{ listItem }}
        </li>
      </ul>
    </div>
    <p class="font-weight-bold my-4 pt-2 cta-text">
      {{ product.payload.callToActionMessage }}
    </p>
    <router-link
      v-if="showBrochureLink"
      :to="{ path: `${product.internalName}/programs-and-details` }"
      class="font-weight-500 text-primary"
      @click.native="trackClick(`${product.category}.${product.internalName}`, 'brochure')"
    >
      {{ $t(`message.spotlightV2.categories.protection.viewBrochure`) }}
    </router-link>
  </protection-base>
</template>

<script>
import log from '@/services/log';
import SpotlightConstants from '@/utils/enums/spotlightConstants';
import ProtectionBase from '@/modules/spotlight/components/categories/protection/ProtectionBaseWithVendorLogo.vue';
import VideoPlayer from '@/modules/spotlight/components/SpotlightVideoPlayer.vue';

export default {
  name: 'ProtectionProductInformation',
  components: {
    ProtectionBase,
    VideoPlayer,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isLubrico() {
      return this.product.internalName === SpotlightConstants.internalNames.vendors.lubrico_warranty.LUBRICO_WARRANTY;
    },
    showVideoPlayer() {
      return (
        Object.prototype.hasOwnProperty.call(this.product.payload, 'videoLinks') &&
        this.product.payload.videoLinks.length
      );
    },
    showMoreVideosLink() {
      return (
        Object.prototype.hasOwnProperty.call(this.product.payload, 'videoLinks') &&
        this.product.payload.videoLinks.length > 1
      );
    },
    showBrochureLink() {
      return (
        Object.prototype.hasOwnProperty.call(this.product.payload, 'brochureLinks') &&
        this.product.payload.brochureLinks.length
      );
    },
  },
  methods: {
    trackClick(product, element) {
      // Analytics tracking
      const payload = {
        elementInteractedWith: `spotlight.${product}.${element}.click`,
      };
      this.$store.dispatch('metrics/logModalInteraction', payload).catch(error => {
        log('Error in logging interaction', error);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
ul.benefits-list {
  li {
    color: $primary-grey;
  }
}

.cta-text {
  color: $primary-grey;
}
</style>
